"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=dataElementGroupSet.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/lib/model/config/model-defaults/dataElementGroupSet.js
// module id = 578
// module chunks = 0